// import { LoadScript } from '@react-google-maps/api';
// import { Library } from '@googlemaps/js-api-loader';
// import Loading from './components/Common/Loading';
//
// const GOOGLE_API_LIBS: Library[] = ['places', 'maps'];
//
// function GoogleMapsProvider({ children }: React.PropsWithChildren) {
//   return children;
//   /* return (
//     <LoadScript
//       googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}
//       libraries={GOOGLE_API_LIBS}
//       language="en"
//       region="US"
//       loadingElement={<Loading absolute />}
//     >
//       {children}
//     </LoadScript>
//   ); */
// }
//
// export default GoogleMapsProvider;

import React, { createContext, useContext, useMemo } from 'react';
import { useJsApiLoader, Libraries } from '@react-google-maps/api';

const GOOGLE_API_LIBS: Libraries = ['places', 'maps'];

interface GoogleMapsContextType {
  isLoaded: boolean;
  loadError: Error | undefined;
}

const GoogleMapsContext = createContext<GoogleMapsContextType>({
  isLoaded: false,
  loadError: undefined,
});

export default function GoogleMapsProvider({ children }: React.PropsWithChildren) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
    libraries: GOOGLE_API_LIBS,
    language: 'en',
    region: 'US',
  });

  const memoizedValues = useMemo(() => ({
    isLoaded, loadError,
  }), [isLoaded, loadError]);

  return (
    <GoogleMapsContext.Provider value={memoizedValues}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

// 4. Custom Hook for easy usage in child components
export const useGoogleMapsContext = () => useContext(GoogleMapsContext);
